export function isTruthy<T>(value: T | null | undefined | false): value is T {
  return !!value;
}

export function assertNever(message: string, obj: never): never {
  throw new Error(message);
}

export function assert(condition: any, message?: string): asserts condition {
  if (!condition) {
    throw new Error(message || 'Assertion failure');
  }
}

export function isEnumMember<T extends object>(
  enumObj: T,
  value: unknown,
): value is T[keyof T] {
  return Object.values(enumObj).includes(value);
}

export function parseValue<T>(value: string): T | null {
  try {
    return JSON.parse(value);
  } catch (err) {
    return null;
  }
}

export function isObjKey<T extends object>(
  key: PropertyKey,
  obj: T,
): key is keyof T {
  return key in obj;
}
